import { Image } from 'app/shared/models/image.model';
import { formatDatePublish } from 'app/shared/utils/utils';

export class LivreDuMois {
  static fromObject(object: any) {
    return new LivreDuMois(
      object.book_id,
      typeof object.book_slug !== 'undefined' ? object.book_slug : '',
      object.book_newspaper,
      object.book_category,
      object.book_title,
      object.book_subtitle,
      object.book_author,
      object.book_description,
      object.book_various_content,
      object.book_on_timeline,
      object.book_eliseuse_url,
      formatDatePublish(object.book_publish_on),
      typeof object.book_image !== 'undefined' ? object.book_image.url : '',
      typeof object.book_cover !== 'undefined' ? object.book_cover.url : '',
      typeof object.book_edition_image !== 'undefined' ? object.book_edition_image.url : '',
      typeof object.book_header_color !== 'undefined' ? object.book_header_color : null,
      typeof object.book_logo !== 'undefined' ? object.book_logo : '',
      typeof object.book_tagline !== 'undefined' ? object.book_tagline : '',
      object.favorite
    );
  }

  constructor(
    public id: string,
    public slug: string,
    public newspaper: string,
    public category: string,
    public title: string,
    public subtitle: string,
    public author: string,
    public description: string,
    public various_content: string,
    public book_on_timeline: boolean,
    public eliseuse_url: string,
    public publish_on: Date,
    public image_url: string,
    public cover_url: string,
    public edition_image_url: string,
    public header_color?: string,
    public logo?: Image,
    public tagline?: string,
    public favorite?: boolean
  ) {}
}
